/** Chart colours for a played game by how a bet on it settles; a push is neutral, neither hit nor miss. */

import type { BetOutcome } from '@parlay-picker/shared/lineOutcome';

interface OutcomeStyle {
  text: string;
  glow: string;
  tooltip: string;
  arrow: string;
  card: string;
  /** A CSS colour for the bar's gradient. */
  color: string;
}

export const OUTCOME_STYLE: Record<BetOutcome, OutcomeStyle> = {
  hit: {
    text: 'text-theme-success',
    glow: 'shadow-theme-success/20',
    tooltip: 'bg-theme-success/10 border-theme-success/30 backdrop-blur-sm',
    arrow: 'border-t-theme-success/30',
    card: 'bg-theme-success/10 border-theme-success/20',
    color: 'var(--color-theme-success)',
  },
  miss: {
    text: 'text-theme-danger',
    glow: 'shadow-theme-danger/20',
    tooltip: 'bg-theme-danger/10 border-theme-danger/30 backdrop-blur-sm',
    arrow: 'border-t-theme-danger/30',
    card: 'bg-theme-danger/10 border-theme-danger/20',
    color: 'var(--color-theme-danger)',
  },
  push: {
    text: 'text-theme-text-tertiary',
    glow: 'shadow-theme-text-tertiary/20',
    tooltip: 'bg-theme-surface border-theme-border backdrop-blur-sm',
    arrow: 'border-t-theme-border',
    card: 'bg-theme-surface/60 border-theme-border',
    color: 'var(--color-theme-text-tertiary)',
  },
};

/** The bar fill: the outcome's colour, darker at the bottom. */
export function outcomeGradient(outcome: BetOutcome): string {
  const { color } = OUTCOME_STYLE[outcome];
  return `linear-gradient(to top, ${color} 0%, color-mix(in srgb, ${color} 65%, white) 100%)`;
}
